<template>
	<div>
		<app-table
			class="mt-3 no-main-list"
			name="role-access-action"
			selectable
			:selected-value="selectedValue"
			:check-all="checkAll"
			:columns="columns"
			:main-list="false"
			:rows="rows"
			@on-search-event="onSearch"
			@on-selected-all="allIsSelected"
			@row-is-selected="rowIsSelected"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.code }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.codeWeb }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.numFragment }}
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
	function allIsSelected(row) {
		this.$emit('all-is-selected', row);
	}

	function onSearch(value) {
		this.$emit('on-search', value);
	}

	function rowIsSelected(row) {
		this.$emit('row-is-selected', row);
	}

	export default {
		name: 'resource-action-list',
		methods: {
			allIsSelected,
			onSearch,
			rowIsSelected,
		},
		props: {
			checkAll: {
				type: Boolean,
				required: true,
			},
			columns: {
				type: Array,
				required: true,
			},
			rows: {
				type: Array,
				required: true,
			},
			selectedValue: {
				type: String,
				required: true,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-access-action-list.vue